import React, { Component, Fragment, Suspense, lazy } from "react";
import { BrowserRouter, Route, Redirect } from "react-router-dom";

import ScrollToTop from "./utils/ScrollToTop";
import "./assets/base.scss";

import { DBConfig } from "./_services/idb";
import { initDB } from "react-indexed-db";
import { library } from "@fortawesome/fontawesome-svg-core";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  fab,
  faFacebook,
  faTwitter,
  faVuejs,
  faReact,
  faHtml5,
  faGoogle,
  faInstagram,
  faPinterest,
  faYoutube,
  faDiscord,
  faSlack,
  faDribbble,
  faGithub
} from "@fortawesome/free-brands-svg-icons";
import {
  far,
  faSquare,
  faLifeRing,
  faCheckCircle,
  faTimesCircle,
  faDotCircle,
  faThumbsUp,
  faComments,
  faFolderOpen,
  faTrashAlt,
  faFileImage,
  faFileArchive,
  faCommentDots,
  faFolder,
  faKeyboard,
  faCalendarAlt,
  faEnvelope,
  faAddressCard,
  faMap,
  faObjectGroup,
  faImages,
  faUser,
  faLightbulb,
  faGem,
  faClock,
  faUserCircle,
  faQuestionCircle,
  faBuilding,
  faBell,
  faFileExcel,
  faFileAudio,
  faFileVideo,
  faFileWord,
  faFilePdf,
  faFileCode,
  faFileAlt,
  faEye,
  faChartBar
} from "@fortawesome/free-regular-svg-icons";
import {
  fas,
  faAngleDoubleRight,
  faAngleDoubleLeft,
  faSmile,
  faHeart,
  faBatteryEmpty,
  faBatteryFull,
  faChevronRight,
  faSitemap,
  faPrint,
  faMapMarkedAlt,
  faTachometerAlt,
  faAlignCenter,
  faExternalLinkAlt,
  faShareSquare,
  faInfoCircle,
  faSync,
  faQuoteRight,
  faStarHalfAlt,
  faShapes,
  faCarBattery,
  faTable,
  faCubes,
  faPager,
  faCameraRetro,
  faBomb,
  faNetworkWired,
  faBusAlt,
  faBirthdayCake,
  faEyeDropper,
  faUnlockAlt,
  faDownload,
  faAward,
  faPlayCircle,
  faReply,
  faUpload,
  faBars,
  faEllipsisV,
  faSave,
  faSlidersH,
  faCaretRight,
  faChevronUp,
  faPlus,
  faLemon,
  faChevronLeft,
  faTimes,
  faChevronDown,
  faFilm,
  faSearch,
  faEllipsisH,
  faCog,
  faArrowsAltH,
  faPlusCircle,
  faAngleRight,
  faAngleUp,
  faAngleLeft,
  faAngleDown,
  faArrowUp,
  faArrowDown,
  faArrowRight,
  faArrowLeft,
  faStar,
  faSignOutAlt,
  faLink
} from "@fortawesome/free-solid-svg-icons";
import ShowError from "_shared/error";
import { getJobs } from "redux/dashboard/action";
import { RouteNames } from "_route-names/route-names";
import { isSessionComplete } from "_shared/authSession";
import {
  syncPushTokenAfterAuth,
  setupPushTokenResyncListeners,
  setupForegroundPushMessageHandler
} from "utils/pushNotifications";
library.add(
  far,
  faSquare,
  faLifeRing,
  faCheckCircle,
  faTimesCircle,
  faDotCircle,
  faThumbsUp,
  faComments,
  faFolderOpen,
  faTrashAlt,
  faFileImage,
  faFileArchive,
  faCommentDots,
  faFolder,
  faKeyboard,
  faCalendarAlt,
  faEnvelope,
  faAddressCard,
  faMap,
  faObjectGroup,
  faImages,
  faUser,
  faLightbulb,
  faGem,
  faClock,
  faUserCircle,
  faQuestionCircle,
  faBuilding,
  faBell,
  faFileExcel,
  faFileAudio,
  faFileVideo,
  faFileWord,
  faFilePdf,
  faFileCode,
  faFileAlt,
  faEye,
  faChartBar
);
library.add(
  fab,
  faFacebook,
  faTwitter,
  faVuejs,
  faReact,
  faHtml5,
  faGoogle,
  faInstagram,
  faPinterest,
  faYoutube,
  faDiscord,
  faSlack,
  faDribbble,
  faGithub
);
library.add(
  fas,
  faAngleDoubleRight,
  faAngleDoubleLeft,
  faSmile,
  faHeart,
  faBatteryEmpty,
  faBatteryFull,
  faChevronRight,
  faSitemap,
  faPrint,
  faMapMarkedAlt,
  faTachometerAlt,
  faAlignCenter,
  faExternalLinkAlt,
  faShareSquare,
  faInfoCircle,
  faSync,
  faQuoteRight,
  faStarHalfAlt,
  faShapes,
  faCarBattery,
  faTable,
  faCubes,
  faPager,
  faCameraRetro,
  faBomb,
  faNetworkWired,
  faBusAlt,
  faBirthdayCake,
  faEyeDropper,
  faUnlockAlt,
  faDownload,
  faAward,
  faPlayCircle,
  faReply,
  faUpload,
  faBars,
  faEllipsisV,
  faSave,
  faSlidersH,
  faCaretRight,
  faChevronUp,
  faPlus,
  faLemon,
  faChevronLeft,
  faTimes,
  faChevronDown,
  faFilm,
  faSearch,
  faEllipsisH,
  faCog,
  faArrowsAltH,
  faPlusCircle,
  faAngleRight,
  faAngleUp,
  faAngleLeft,
  faAngleDown,
  faArrowUp,
  faArrowDown,
  faArrowRight,
  faArrowLeft,
  faStar,
  faSignOutAlt,
  faLink
);

const Routes = lazy(() => import("./Routes"));
const ShowSnackbar = lazy(() => import("./_shared/show-snackbar.jsx"));
const ShowNotification = lazy(() => import("_shared/show-notification"));
const CssBaseline = lazy(() => import("@material-ui/core/CssBaseline"));
class App extends Component {
  constructor() {
    super();
    initDB(DBConfig);
  }

  componentDidMount() {
    setupPushTokenResyncListeners();
    setupForegroundPushMessageHandler();
    this.tryFetchData();
  }

  componentDidUpdate(prevProps) {
    const propsChanged = this.props.isAuthenticated !== prevProps.isAuthenticated || this.props.isProfileComplete !== prevProps.isProfileComplete;

    if (propsChanged) {
      this.tryFetchData();
    }
  }

  tryFetchData = () => {
    const { isAuthenticated, isProfileComplete, role, getJobs } = this.props;
    if (isAuthenticated) {
      syncPushTokenAfterAuth();
    }
    if (isSessionComplete({ isLoggedIn: isAuthenticated, isProfileComplete, role })) {
      getJobs();
    }
  };

  render() {
    const { isAuthenticated, isProfileComplete, role } = this.props;
    const sessionComplete = isSessionComplete({ isLoggedIn: isAuthenticated, isProfileComplete, role });
    const step = JSON.parse(localStorage.getItem("step"));

    return (
      <Fragment>
        <BrowserRouter>
          <ScrollToTop>
            <Suspense fallback={<div></div>}>
              <Route
                exact
                path="/"
                render={() =>
                  sessionComplete && !step ? <Redirect to={RouteNames.dashboard} /> : <Redirect to={RouteNames.login} />
                }
              />
              <Routes />
            </Suspense>
          </ScrollToTop>
          <Suspense fallback={<div></div>}>
            <CssBaseline />
          </Suspense>
        </BrowserRouter>
        <Suspense fallback={<div></div>}>
          <ShowSnackbar />
          <ShowError />
        </Suspense>
        <Suspense fallback={<div></div>}>
          <ShowNotification />
        </Suspense>
      </Fragment>
    );
  }
}
const mapStateToProps = (state) => ({
  isAuthenticated: state.user.userData.isLoggedIn || false,
  isProfileComplete: state.user.userData.isProfileComplete,
  role: state.user.userData.role
});

const mapDispatchToProps = (dispatch) => ({
  getJobs: () => dispatch(getJobs({ tab: 0 }))
});

App.propTypes = {
  getJobs: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  isProfileComplete: PropTypes.bool.isRequired,
  role: PropTypes.string.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
